// react
/* eslint-disable */
/* eslint-disable prefer-template */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable object-curly-spacing */
/* eslint-disable quotes */
/* eslint-disable import/order */
/*eslint linebreak-style: ["error", "windows"]*/
// react
import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl, ViewImg } from "../services/service";
// third-party
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PageHeader from "../shared/PageHeader";
// data stubs
import dataAddresses from "../../data/accountAddresses";
import theme from "../../data/theme";
import "../account/AddressCard.css";

export default function ShopPageAddress() {
    const UserID = localStorage.getItem("UserID");
    const UserEmail = localStorage.getItem("UserEmail");
    const [CardData, setCardData] = useState([]);

    const GetAddress = () => {
        axios.get(MyApiUrl + "UserAddress/" + UserID + "").then((response) => {
            console.log(response);
            if (response.data.length != "0") {
                setCardData(response.data);
            }
        });
    };
    React.useEffect(() => {
        GetAddress();
    }, []);
    const addresses = CardData.map((val, key) => (
        <React.Fragment key={val.user_address_pkid}>
            <div className="addr-card">
                <Link
                    to={{
                        pathname: "/shop/checkout",
                        state: { address: val },
                    }}
                    style={{ color: "black" }}
                >
                    <div className="addr-top">
                        <div>
                            <h4 className="addr-name">{val.user_address_name}</h4>
                            <span className="addr-type">{val.user_address_type}</span>
                        </div>

                        {(val.user_address_default === 1 || val.user_address_default === "1") && (
                            <span className="addr-default">Default</span>
                        )}
                    </div>

                    <div className="addr-body">
                        <p className="addr-text">
                            {val.user_address_house_no}, {val.user_address_street}
                            <br />
                            {val.area_name}, {val.city_name}, {val.state_name}
                            <br />
                            {val.country_name} - {val.user_address_zipcode}
                        </p>

                        <div className="addr-meta">
                            <span>📞 {val.user_address_phone}</span>
                            <span>✉️ {UserEmail}</span>
                        </div>
                    </div>
                </Link>
            </div>

            <div className="addresses-list__divider" />
        </React.Fragment>
    ));

    const breadcrumb = [
        { title: "Home", url: "" },
        { title: "Shopping Cart", url: "/shop/cart" },
        { title: "Shipping Details", url: "/shop/address" },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Our Products — ${theme.name}`}</title>
            </Helmet>
            <PageHeader header="Shipping Details" breadcrumb={breadcrumb} />
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h5 style={{ textAlign: "center" }}>Select Your Shipping Address</h5>
                    </div>
                </div>

                <div className="addresses-list" style={{ padding: 10 }}>
                    {addresses}
                </div>
            </div>
        </React.Fragment>
    );
}
